
<template>
  <div>
    <v-dialog 
      v-model="dialog" 
      scrollable 
      persistent 
      :overlay="true" 
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Editando dados da obra</span>
        </v-card-title>
        <v-card-text>
          <BuildingForm ref="form" :building="building"></BuildingForm>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="closeDialog">Cancelar</f-btn>
          <f-btn save @click="updateBuilding">Salvar</f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'DialogEditAddress',
  components: {
    BuildingForm: () => import('@/_backoffice/_registrations/components/buildings/forms/BuildingForm.vue'),
  },
  props: {
    model_building: {
      type: Object,
      required: true,
    },
    dialog:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saving: false,
      building: {}
    }
  },
  methods: {
    setBuilding(){
      this.building = JSON.parse(JSON.stringify(this.model_building))
    },
    closeDialog(){
      this.$emit('closeDialog', 'building')
    },  
    updateBuilding() {
      if(this.$refs.form.validate()){
        this.saving = true

        let {id, name, comment } = this.building
        let building = { id, name, comment}
        Api.Building.update(building).then(r=> r.data).then(d=> {
          this.successUpdated()
          this.$emit('updated', 'building')
        }).catch(err=>{
          console.log(err)
          this.errorUpdated()
        }).finally(() => {
          this.saving = false
          this.closeDialog()
        })
      }
    },
  },
  mounted () {
    this.setBuilding();
  },
}
</script>